import React, { useEffect, useState } from 'react';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import css from './SubscribeForm.module.css';
import { post } from '../../util/api';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import Button from '../Button/Button';
import * as validators from '../../util/validators';

const SubscribeForm = props => {
    const { intl } = props;
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isBusy, setIsBusy] = useState(false);


    const onSubmit = values => {
        const requestOperatorOptions = {
            subject: intl.formatMessage({ id: 'SubscribeForm.EmailSubject' }),
            text: `<p>${intl.formatMessage({ id: 'SubscribeForm.EmailBodyDetails' })}</p>
          <p>${intl.formatMessage({
                id: 'SubscribeForm.Email',
            })}: ${values.userEmail.trim()}</p>
          `,
        };

        setIsBusy(true);
        post('/api/sendgrid-operator-email', requestOperatorOptions)
            .then(response => {
                setIsSubscribed(true);
                setIsBusy(false);
            })
            .catch(e => {
                setIsBusy(false);
            });
    };

    const required = validators.required(intl.formatMessage({ id: 'SubscribeForm.Required' }));
    const valid = validators.emailFormatValid(
        intl.formatMessage({ id: 'SubscribeForm.Invalid' })
    );


    return (
        <div className={css.popupWrapper}>

            {isSubscribed ? (
                <div className={css.root}>
                    <p className="titleBlueSmall">
                        <FormattedMessage id="SubscribeForm.ThankYou" />
                    </p>
                </div>
            ) : (
                <div className={css.root}>

                    <label className={css.title}>
                        <FormattedMessage id="SubscribeForm.Title" />
                    </label>

                    <FinalForm
                        onSubmit={onSubmit}
                        render={fieldRenderProps => {
                            const { handleSubmit, invalid, pristine, submitting } = fieldRenderProps;
                            const submitDisabled = invalid || pristine || submitting;

                            return (
                                <form
                                    className={css.formContainer}
                                    onSubmit={e => {
                                        e.preventDefault();
                                        handleSubmit(e);
                                    }}
                                >
                                    <FieldTextInput
                                        inputRootClass={css.field}
                                        type="text"
                                        id="userEmail"
                                        name="userEmail"
                                        placeholder={intl.formatMessage({ id: 'SubscribeForm.Email' })}
                                        validate={validators.composeValidators(required, valid)}
                                    />

                                    <Button className={css.button} type="submit" disabled={submitDisabled}
                                        inProgress={isBusy}>
                                        {intl.formatMessage({ id: 'SubscribeForm.Submit' })}
                                    </Button>
                                </form>
                            );
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default SubscribeForm;